import React, {useEffect, useState} from 'react'
import Head from 'next/head'
import {HStack, VStack} from '@components/Stack'
import {InnerPageHeader} from '@components/InnerPageHeader'
import {
  BattleStatuses,
  battles,
  getBattleStatus,
} from '@cssbattle/shared/battles'
import {BattleTile} from 'src/BattleTile'
import {GlobalLeaderBoard} from 'src/GlobalLeaderBoard'
import {Text} from '@components/Text'
import {Panel} from '@components/Panel'
import {getRedirectLink} from 'src/utils'
import Link from 'next/link'
import {ActivityStream} from 'src/ActivityStream'
import {Button} from 'src/Button'
import {CreateBattleModal} from 'src/CreateBattleModal'
import {MacOSDock} from 'src/MacOSDock'

const BattlesPage = () => {
  const [isCreateBattleModalOpen, setIsCreateBattleModalOpen] = useState(false)
  const list = [...battles]
  list.reverse()

  function hostBattleHandler() {
    setIsCreateBattleModalOpen(true)
  }

  const finishedBattleIndex = list.findIndex(
    (battle) => getBattleStatus(battle) === BattleStatuses.FINISHED
  )

  return (
    <>
      <Head>
        <title key="title">Battles | CSSBattle</title>
        <meta property="og:title" content="Battles - CSSBattle" key="ogTitle" />
      </Head>

      <div style={{maxWidth: '100%'}}>
        <VStack gap="3rem">
          <VStack gap="2rem">
            <InnerPageHeader
              icon="battle"
              title="Battles"
              subtitle="Compete with players around the world in these nail-biting battles"
            />

            <HStack gap="0.75rem">
              <Button onClick={() => hostBattleHandler()}>
                Host a private battle
              </Button>
              <Link href="/advertise">
                <a className="button">Advertise in a battle</a>
              </Link>
              <Link href="/my-battles">
                <a className="button">My battles</a>
              </Link>
            </HStack>
          </VStack>

          <div style={{width: '100%'}}>
            <ActivityStream />
          </div>

          <HStack align="flex-start" gap="3rem" responsive>
            <VStack align="stretch" gap="3rem">
              {list.slice(0, finishedBattleIndex).length ? (
                <VStack align="stretch">
                  <Text size={3} weight="600" mono={false} appearance="primary">
                    Play latest battle
                  </Text>

                  {list.slice(0, finishedBattleIndex).map((battle) => (
                    <BattleTile key={battle.id} battle={battle} fullWidth />
                  ))}
                </VStack>
              ) : null}

              <VStack gap="3rem" align="stretch">
                <VStack align="stretch">
                  <Text size={3} weight="600" mono={false} appearance="primary">
                    Play past battles
                  </Text>

                  <VStack gap="2rem" align="stretch">
                    {list.slice(finishedBattleIndex).map((battle) => (
                      <BattleTile key={battle.id} battle={battle} />
                    ))}
                  </VStack>
                </VStack>
              </VStack>
            </VStack>
            <div style={{minWidth: '18rem', width: '18rem', flex: '0 0 0'}}>
              <GlobalLeaderBoard />
            </div>
          </HStack>
        </VStack>
      </div>

      {/* Use the MacOSDock component */}
      <MacOSDock battles={list} />

      <CreateBattleModal
        isOpen={isCreateBattleModalOpen}
        onRequestClose={() => setIsCreateBattleModalOpen(false)}
      />
    </>
  )
}

export default BattlesPage
